import {Component, OnInit} from '@angular/core';
import {LearnCategoryService} from '../../../../core/services/learnCategory.service';
import {SettingFormDialogComponent} from '../organizer-settings/setting-form/setting-form.component';
import {EditLearnCategoryComponent} from './setting-form/edit-learn-category.component';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import {fuseAnimations} from '../../../../core/animations';

@Component({
    selector: 'learn-category',
    templateUrl: './learnCategory.component.html',
    styleUrls: ['./learnCategory.component.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class LearnCategoryComponent implements OnInit {

  learnCategories = [];
  displayedColumns = [ 'name', 'color' ];

  constructor(public learnCategoryService: LearnCategoryService,
              public dialog: MatDialog, public snackBar: MatSnackBar,
              public translate: TranslateService) {
  }

  ngOnInit() {
    this.getLearnCategories();
  }

  getLearnCategories() {
    this.learnCategoryService.getLearnCategories().subscribe((res: any) => {
      if (res) {
        this.learnCategories = res;
      }
    });
  }

  newCategory() {
    let dialogRef = this.dialog.open(EditLearnCategoryComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '400px',
      data: {
        action: 'new'
      }
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.learnCategoryService.addLearnCategory(res).subscribe((cat: any) => {
          if (cat) {
            this.snackBar.open(this.translate.instant('learn_category_added'), '', {duration: 2500});
            this.getLearnCategories();
          }
        });
      }
    });
  }

  editCategory(lc) {
    let dialogRef = this.dialog.open(EditLearnCategoryComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '400px',
      data: {
        type: lc.name ,
        action: 'edit'
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        const actionType: string = res[0];
        const data = res[1];
        switch (actionType) {
          case 'save':
            this.learnCategoryService.addLearnCategory({name: data.name, id: lc.id, color: data.color}).subscribe((cat: any) => {
              if (cat) {
                this.snackBar.open(this.translate.instant('learn_category_edited'), '', {duration: 2500});
                this.getLearnCategories();
              }
            });
            break;

          case 'delete':
            this.learnCategoryService.deleteLearnCategory(lc.id).subscribe((cat: any) => {
              this.snackBar.open(this.translate.instant('learn_category_deleted'), '', {duration: 2500});
              this.getLearnCategories();
            });

            break;
        }
      }
    });
  }
}
